// challenge-detail-modal.component.ts
import { Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ChallengeDetail } from 'src/interfaces/challenge-details.interface';
import { Order } from 'src/interfaces/order.interface';
import { GlobalStateModel } from 'src/store/state.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '@modules/utility/services/utility.service';
import { NavigationService } from '@modules/navigation/services';

@Component({
  selector: 'app-challenge-detail-modal',
  templateUrl: './challenge-details-modal.component.html',
  styleUrls: ['./challenge-details-modal.component.scss'],
})
export class ChallengeDetailModalComponent implements OnChanges {
  order$: Observable<Order> = inject(Store).select((state: GlobalStateModel) => state.order.order);

  @Input() challengeDetail: ChallengeDetail;

  routeToOrderLoading = false;

  constructor(
    private modal: NgbModal,
    private utilityService: UtilityService,
    private navigation: NavigationService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['challengeDetail'] && changes['challengeDetail'].currentValue) {
      console.log('Modal received challenge details past_completions:', this.challengeDetail.past_completions);
      console.log('Full challenge details in modal:', this.challengeDetail);
    }
  }

  close() {
    this.modal.dismissAll();
  }

  openOrderTypeModal() {
    this.routeToOrderLoading = true;
    this.close();

    // Check if there's an active order
    this.order$.subscribe(order => {
      if (order && order.orderID) {
        // If there's an active order, navigate to the menu
        this.navigation.navigateToMenuPage(order.location.locationID);
      } else {
        // If no active order, open the order type modal
        this.utilityService.openOrderTypeModalEvent.emit();
      }
      this.routeToOrderLoading = false;
    });
  }
}
